module.exports = __webpack_public_path__ + "static/media/PB.1e7da92d.jpg";